import React from 'react'

const CustomPayIcon = (props) => {
  const iconStyle = {
    fill: props.color,
    padding: 10
  }

  return (
    <svg height="100" width="100" style={iconStyle} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path d="M256 6C117.9 6 6 117.9 6 256s111.9 250 250 250 250-111.9 250-250S394.1 6 256 6zm-26.9 224.5c6.8 6.8 16 10.8 25.7 11h1.3c37.7 0 68.7 30.7 68.7 68.7 0 32-22.3 59.5-52.7 66.9V406h-32v-28.8c-12.3-2.9-23.4-9.1-32.5-18.1-11.2-11.3-18.4-26.5-19.9-42.2l-.8-9.1h30.7l.8 7.3c1 8.7 4.7 16.3 10.8 22.3 7.1 7.1 16.8 11 26.7 11 21 0 38-17 38-38 0-20.5-16.3-37.3-36.7-38h-1.3c-18.4 0-35.7-7.1-48.5-20.2-12.8-12.8-20.2-30.2-20.2-48.5 0-32 22.3-59.5 52.7-66.9V106h32v30.7c28.6 6.8 50.1 31.5 52.4 61.3l.8 8.9h-30.4l-.8-7.3c-2.1-19.4-18.4-34.1-37.7-34.1-21 0-38 17-38 38-.3 10.3 3.6 19.7 10.9 27z"/>
    </svg>
  )
}


  export default CustomPayIcon